import {
  CreateIpListRequest,
  CreateIpListResponse,
  DeleteIpItemResponse,
  GetIpListResponse,
  UpdateIpListItemRequest,
  UpdateIpListItemResponse,
} from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { CustomAxios, getResponseData } from '../../redux/axios';
import { getDefaultLocationId } from '../auth/default-location';

const IP_LIST_URL = '/auth-api/v3/weave/system/ip';

export const getIpList = async (): Promise<GetIpListResponse> => {
  const response = await CustomAxios.get<GetIpListResponse>(IP_LIST_URL, {
    headers: { 'Location-Id': getDefaultLocationId() },
  });
  return getResponseData<GetIpListResponse>(response);
};

export const updateIpListItem = async (request: UpdateIpListItemRequest) => {
  const response = await CustomAxios.post<UpdateIpListItemResponse>(
    IP_LIST_URL,
    request,
    { headers: { 'Location-Id': getDefaultLocationId() } }
  );
  return getResponseData<UpdateIpListItemResponse>(response);
};

export const createIpListItem = async (request: CreateIpListRequest) => {
  const response = await CustomAxios.put<CreateIpListResponse>(IP_LIST_URL, request, {
    headers: { 'Location-Id': getDefaultLocationId() },
  });
  return getResponseData<CreateIpListResponse>(response);
};

export const deleteIpItem = async (id: string) => {
  const response = await CustomAxios.delete<DeleteIpItemResponse>(
    `${IP_LIST_URL}/${encodeURIComponent(id)}`,
    { headers: { 'Location-Id': getDefaultLocationId() } }
  );
  return getResponseData<DeleteIpItemResponse>(response);
};
